export enum EduTradingTradeContentTab {

    Brokers = "brokers",
    Trade = "trade",
    Connect = "connect",
    Review = "review",
}
